import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UnitPermissionsModel } from '../share-panel';

@Component({
  selector: 'bulb-share-toggle-text',
  templateUrl: './share-toggle-text.component.html',
  styleUrls: ['./share-toggle-text.component.scss'],
  standalone: false,
})
export class ShareToggleTextComponent implements OnInit {
  public translationKey = '';

  public inherited: boolean;

  @Input() privacySetting: Observable<UnitPermissionsModel>;

  ngOnInit() {
    this.privacySetting.subscribe(
      (setting) => {
        this.setTranslationKey(setting.privacyLevel.level);
        this.inherited = setting.privacyLevel.inherited !== 'PRIVATE';
      },
    );
  }

  private setTranslationKey(privacyLevel) {
    if (privacyLevel === 'PUBLIC') {
      this.translationKey = 'sharePanel.toggleText.public';
    } else if (privacyLevel === 'CUSTOM') {
      this.translationKey = 'sharePanel.toggleText.custom';
    } else if (privacyLevel === 'PRIVATE') {
      this.translationKey = 'sharePanel.toggleText.private';
    }
  }
}
